module.exports = __webpack_public_path__ + "static/img/food-img-2.7e5d9f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/food-img-2.png
// module id = Phk/
// module chunks = 1